import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaUser, FaSignInAlt } from "react-icons/fa";
import { IoMenu, IoClose } from "react-icons/io5";

import logo from "../assets/logo.png";
import NavBtn from "./NavBtn";

function Navbar(props) {
  const { homeRef, sendRef, howRef, contactRef, stickyNavbar } = props;
  const [sideMenuIsOpen, setSideMenuIsOpen] = useState(false);

  const onSideMenuOpen = () => {
    setSideMenuIsOpen(!sideMenuIsOpen);
  };

  const updatePage = () => {
    let currentPath = window.location.pathname;
    if (currentPath !== "/") {
      window.location.href = "/";
    }
  };

  const navLinks = [
    {
      type: "link",
      name: "Home",
      handleClick: () => {
        updatePage();
        homeRef.current.scrollIntoView(true);
        if (sideMenuIsOpen) {
          onSideMenuOpen();
        }
      },
    },
    {
      type: "link",
      name: "Send Money",
      handleClick: () => {
        updatePage();
        sendRef.current.scrollIntoView(true);
        if (sideMenuIsOpen) {
          onSideMenuOpen();
        }
      },
    },
    {
      type: "link",
      name: "How it works",
      handleClick: () => {
        updatePage();
        howRef.current.scrollIntoView(true);
        if (sideMenuIsOpen) {
          onSideMenuOpen();
        }
      },
    },
    {
      type: "link",
      name: "Contact Us",
      handleClick: () => {
        updatePage();
        contactRef.current.scrollIntoView(true);
        if (sideMenuIsOpen) {
          onSideMenuOpen();
        }
      },
    },
    {
      type: "btn",
      name: "Sign up",
      loc: "/sign-up",
      icon: <FaUser />,
      handleClick: (e) => {
        if (sideMenuIsOpen) {
          onSideMenuOpen();
        }
      },
    },
    {
      type: "btn",
      name: "Login",
      loc: "/login",
      icon: <FaSignInAlt />,
      handleClick: (e) => {
        if (sideMenuIsOpen) {
          onSideMenuOpen();
        }
      },
    },
  ];

  return (
    <nav
      className={
        stickyNavbar
          ? "w-100 position-fixed start-0 top-0 bg-white z-index-to-150 shadow-sm"
          : "position-absolute start-0 top-0 w-100 z-index-to-150"
      }
    >
      <div className="container py-3">
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <Link className="navbar-brand" to="/">
              <a className="text-dark text-decoration-none">Logo</a>
            </Link>
          </div>
          <div>
            <div className="d-none d-lg-block">
              <ul className="list-unstyled mb-0 d-flex align-items-center">
                {navLinks.map((nav) =>
                  nav.type === "link" ? (
                    <li
                      key={nav.name}
                      className="d-flex align-items-center full-height me-3 cursor-pointer"
                    >
                      <button
                        className={`btn border-0 bg-transparent boxshadow-none fs-18 ${
                          stickyNavbar ? "text-primay" : "text-dark"
                        }`}
                        onClick={nav.handleClick}
                      >
                        {nav.name}
                      </button>
                    </li>
                  ) : (
                    <li
                      key={nav.name}
                      className="d-flex align-items-center full-height me-3"
                    >
                      <NavBtn
                        name={nav.name}
                        loc={nav.loc}
                        styl="btn btn-primary rounded-pill d-flex align-items-center boxshadow-none"
                      >
                        {nav.icon}
                      </NavBtn>
                    </li>
                  )
                )}
              </ul>
            </div>
            <div className="d-lg-none">
              <button
                className={`btn bg-transparent border-0 boxshadow-none p-0 fs-3 transition-2s ${
                  stickyNavbar ? "text-primay" : "text-white"
                }`}
                onClick={onSideMenuOpen}
              >
                {sideMenuIsOpen ? <IoClose /> : <IoMenu />}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`position-fixed top-0 start-0 full-height bg-transparent transition-6s z-index-to-150 ${
          sideMenuIsOpen ? "w-100" : "width-0"
        }`}
      >
        <div
          className={`position-absolute top-0 start-0 full-height bg-dark-tranparent transition-6s z-index-1 ${
            sideMenuIsOpen ? "w-100" : "width-0"
          }`}
          onClick={onSideMenuOpen}
        ></div>
        <div
          className={`full-height bg-white z-index-to-5 ${
            sideMenuIsOpen ? "width-280-t max-width-280" : "width-0-t"
          }`}
        >
          <div className={!sideMenuIsOpen ? "hide-element" : "transition-4s"}>
            <div className="d-flex align-items-center justify-content-center height-72 w-100 shadow-sm px-2 bg-primary">
              <Link className="navbar-brand" to="/">
                <a className="text-dark text-decoration-none">Logo</a>
              </Link>
            </div>
            <ul className="list-unstyled p-0">
              {navLinks.map((nav) =>
                nav.type === "link" ? (
                  <li
                    key={nav.name}
                    className="px-2 py-3 border border-gray-300 border-start-0 border-end-0 border-top-0"
                  >
                    <button
                      className="w-100 btn border-0 bg-transparent boxshadow-none fs-18 text-dark"
                      onClick={nav.handleClick}
                    >
                      {nav.name}
                    </button>
                  </li>
                ) : (
                  <li
                    key={nav.name}
                    className="px-2 py-3 border border-gray-300 border-start-0 border-end-0 border-top-0"
                  >
                    <NavBtn
                      name={nav.name}
                      loc={nav.loc}
                      styl="btn btn-primary rounded-pill border border-white d-flex align-items-center justify-content-center boxshadow-none"
                      onClick={nav.handleClick}
                    >
                      {nav.icon}
                    </NavBtn>
                  </li>
                )
              )}
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
